import { ObjectUrlName } from "../../../utils/enums";

export const RELEVANT_FIELDS_BY_OBJECT_URL_NAME: Record<string, string[]> = {
  [ObjectUrlName.Weightings]: ["weighting"]
};
